import Vue from 'vue'
import Vuex from 'vuex'

import * as getters from './getters'
import * as actions from './actions'
import * as state from './state'

import user from './modules/user'
import asta from './modules/asta'
import calciatori from './modules/calciatori'
import squadre from './modules/squadre'
import prefs from './modules/prefs'
import logs from './modules/logs'
import plan from './modules/plan'
import VuexPersist from 'vuex-persist';
import Config from '../../config-app/config'

Vue.use(Vuex)

// const vuexMySquadraConnections = new VuexPersist({
//   key: 'asta-live-' + Config.WEBSITE,
//   storage: window.sessionStorage, 
//   // Function that passes a mutation and lets you decide if it should update the state in localStorage.
//   // filter: mutation => (true)
//   // reducer: (state) => ({myallow: state.myallow}),
//   modules: ['myallow'], 
// })

const store = new Vuex.Store({
  // plugins: [vuexMySquadraConnections.plugin],
  strict: false,
  state,
  getters,
  actions,
  modules: {
    user,
    asta,
    calciatori,
    squadre,
    prefs,
    logs,
    plan
  }
})

export default store